import { EXPIRED_COOKIE, REFRESH_KEY } from '../constants';
const handleLogout = client => {
  document.cookie = EXPIRED_COOKIE;
  window.localStorage.removeItem(REFRESH_KEY);
  return client.clearStore();
};
export default handleLogout;
//# sourceMappingURL=handle-logout.js.map